:host {
  /**
   * @prop --scene-tree-toolbar-content-gap: A CSS length that specifies the
   * horizontal gap between slots.
   */
  --scene-tree-toolbar-content-gap: 8px;

  display: flex;
  padding: 0.5rem;
}

.content {
  display: flex;
  align-items: center;
}

.content-primary {
  width: 100%;
}

::slotted(:not(:first-child)) {
  margin-left: var(--scene-tree-toolbar-content-gap);
}
